/**************************************************
 * Nombre:       TarjetaOferta
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {ArrowRightAlt} from '@mui/icons-material'
import circulo from '../../Recursos/circulo.svg'


const TarjetaOferta = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                border: 1,
                borderColor: '#00000020',
                p: 4,
                overflow: 'hidden',
            }}

        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 2}}>
                <Typography sx={{
                    fontSize: 32,
                    fontWeight: 600,
                    fontFamily: NEGRITA,
                    lineHeight: 1.1
                }}>{item.nombre}</Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>

                {item.items.map((it, index) => (
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{lineHeight: 1.2}}>{it}</Typography>
                    </Grid>
                ))}

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Button variant={'text'} startIcon={<ArrowRightAlt/>} sx={{px: 0}}>Ver Detalle Escuela</Button>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mr: -18, mb: -14,mt: -12}}>
                <img src={circulo} width={250} height={'auto'}/>
            </Grid>

        </Grid>
    )

}
export default TarjetaOferta